import { CONTENT_VIDEO_FULL_DESCRIPTION_MAX_LENGTH } from '@/constants/contentLimits';
import { HStack, Text, Textarea, VStack } from '@chakra-ui/react';
import React from 'react';
import { FieldError } from '../components/FormBits';

type Props = {
  fullDescription: string;
  onChange: (value: string) => void;
  error?: string;
};

const VideoDescriptionStep = ({ fullDescription, onChange, error }: Props) => {
  return (
    <VStack align="stretch" gap="12px" width="100%" maxWidth="640px">
      <Text fontWeight={800} fontSize="20px" color="text.darkBlue" textAlign="center">
        Full Description
      </Text>
      <Textarea
        backgroundColor="white"
        minHeight="180px"
        placeholder="Add full description here."
        maxLength={CONTENT_VIDEO_FULL_DESCRIPTION_MAX_LENGTH}
        value={fullDescription}
        onChange={(e) => onChange(e.target.value)}
      />
      <HStack justify="flex-end">
        <Text fontSize="12px" color="text.mediumGray">
          {fullDescription.length}/{CONTENT_VIDEO_FULL_DESCRIPTION_MAX_LENGTH}
        </Text>
      </HStack>
      <FieldError error={error} />
    </VStack>
  );
};

export default VideoDescriptionStep;
